(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sec = document.getElementById('MorganaHero-{{ section.id }}');
    if (!sec) return;

    // Floating particles
    var wrap = sec.querySelector('.morgana-hero__particles');
    if (wrap && !wrap.dataset.built) {
      wrap.dataset.built = '1';
      var N = 24;
      for (var i = 0; i < N; i++) {
        var p = document.createElement('span');
        p.className = 'morgana-hero__particle';
        var s = Math.random() * 2 + 0.5;
        p.style.width = s + 'px';
        p.style.height = s + 'px';
        p.style.left = (Math.random() * 100) + '%';
        p.style.top = (100 + Math.random() * 20) + '%';
        p.style.animationDuration = (14 + Math.random() * 22) + 's';
        p.style.animationDelay = (-Math.random() * 20) + 's';
        p.style.opacity = (Math.random() * 0.35 + 0.05).toFixed(2);
        wrap.appendChild(p);
      }
    }

    // Mouse parallax on sigil
    var sigil = sec.querySelector('.morgana-hero__visual');
    if (sigil) {
      sec.addEventListener('mousemove', function(e) {
        var rect = sec.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width - 0.5) * 14;
        var y = ((e.clientY - rect.top) / rect.height - 0.5) * 14;
        sigil.style.transform = 'translate(' + x + 'px, calc(-50% + ' + y + 'px))';
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
